'use strict';

import Promise from 'es6-promise';
import Log from '../log';
import Config from '../config/index';
import Lang from '../lang';

const Endpoints = {
    categories: {
        url: '/categories?rootCategoryId=27&depth=2',
        format: formatCategories
    },
    products: {
        url: '/products?searchCriteria[filter_groups][0][filters][0][field]=category_id&searchCriteria[filter_groups][0][filters][0][value]=27',
        format: formatProducts
    },
};

/**
 * Fetch data from api via url
 * @param url
 * @param config
 * @returns {Promise<>}
 * @private
 */
function _query(url, config = null) {
    return new Promise((resolve, reject) => {

        let options = Object.assign({}, config, {
            url,

            datatype: 'json',
            contentType: 'application/json; charset=utf-8',
            headers: {
                Authorization: 'Bearer g8cuix6iduuujb4b326c4l7b2l9bept4'
            }
        });

        $.ajax(options)
            .done((data, status, jqXHR) => {
                Log.trace(`fetched successfully from "${url}"`);
                resolve(data)
            })
            .fail((jqXHR, status, err) => {
                Log.error('error while fetching from api', jqXHR, err);
                reject(err);
            });
    });
}

/**
 * Fetch data from api via endpoint name
 * @param name {string} - Endpoint name
 * @param config
 * @returns {Promise<>}
 */
function query(name, config) {
    const endpoint = Endpoints[name];
    if (!endpoint) return new Promise((resolve, reject) => reject(`No endpoint with name ${name}`));
    //let url = "//ww2.catwalk-kratzbaeume.de/rest/german/V1";
    let url = Lang.get('magento.urlApi') || Config.api.magento;

    return _query(url + endpoint.url, config).then((data) => endpoint.format(data))
}

/* ---------- ENDPOINT FORMAT METHODS ---------- */

function formatProducts(data) {
    Log.trace('products', data);
    return data.items.map((product, index) => {
        let prodFormat = {
            id: index,
            name: product.name,
            sku: product.sku,
            visibility: product.visibility,
            img: {},
            price: product.price
        };

        if (prodFormat.sku === 'config-sisal') Config.idSisalCheap = prodFormat.id;
        if (prodFormat.sku === 'config-sisal-6') Config.idSisalExpensive = prodFormat.id;

        product.custom_attributes.forEach((attr) => {
            if (attr.attribute_code === 'image') prodFormat.img.inventory = Config.api.magentoImg + attr.value;
            if (attr.attribute_code === 'config_sideface') prodFormat.img.designer = Config.api.magentoImg + attr.value;
            if (attr.attribute_code === 'config_rotable') prodFormat.img.rotated = Config.api.magentoImg + attr.value;
            if (attr.attribute_code === 'rotatable') prodFormat.rotable = attr.value === "1";
            if (attr.attribute_code === 'description') prodFormat.description = parseFieldDescription(attr.value);
            if (attr.attribute_code === 'short_description') prodFormat.descriptionShort = attr.value;
            if (attr.attribute_code === 'category_ids') prodFormat.category = attr.value;
            if (attr.attribute_code === 'sisal') prodFormat.hasSisal = (attr.value - 8 || 0);  // undefined & 8 = no sisal; 9 = cheap sisal; 10 = expensive sisal;

            if (!prodFormat.img.designer) prodFormat.img.designer = prodFormat.img.inventory;
        });
        prodFormat.hasSisal = prodFormat.hasSisal || 0;

        return prodFormat;
    });
}

function formatCategories(data) {
    let categories = data.children_data.reduce((obj, item) => {
        obj[item.id] = item;
        return obj;
    }, {});
    categories[data.id] = data;
    return categories;
}

function parseFieldDescription(text) {
    return text
    .replace('<img ', '<img class="item-picker__img" ')
    .replace('{{media url="', Config.api.magentoImgInline + '/')
    .replace('{{media url=&quot;', Config.api.magentoImgInline + '/')
    .replace('"}}', '')
    .replace('&quot;}}', '');
}

export default {
    query,
    _query
}